import { TYPE_TO_KEY } from 'modules/territory/common/territory.consts'

export function getTopicsCurrentKey(item) {
  return TYPE_TO_KEY?.[item?.type] || 'topics'
}
